import { cl } from './index';
import select from 'dom-select';

interface Options {
  rootMargin?: string;
  threshold?: number;
  class?: string;
  once?: boolean;
  target?: HTMLElement;
  callback?: (visible?: boolean, target?: any, entry?: any) => void;
}
export class Observer {
  options: Options = {
    rootMargin: '0% 0% -30% 0%',
    threshold: 0,
    once: true,
  };
  observer: IntersectionObserver;

  constructor(options?: Options) {
    if (options) {
      this.options = { ...this.options, ...options };
    }
    this.observer = new IntersectionObserver(this.onIntersection.bind(this), {
      rootMargin: options.rootMargin,
      threshold: options.threshold,
    });

    return this;
  }

  add(selector: string | HTMLElement, parent?: HTMLElement) {
    this.disconnect();
    if (typeof selector === 'string') {
      select.all(selector, parent).forEach((el: HTMLElement) => {
        this.observer.observe(el);
      });
    } else {
      this.observer.observe(selector);
    }
  }

  addArray(elements: Element[]) {
    this.disconnect();
    elements.forEach(element => {
      this.observer.observe(element);
    })
  }

  remove(selector: string | HTMLElement, parent?: HTMLElement) {
    if (typeof selector === 'string') {
      select.all(selector, parent).forEach((el: HTMLElement) => {
        this.observer.unobserve(el);
      });
    } else {
      this.observer.unobserve(selector);
    }
  }

  onIntersection(entries: IntersectionObserverEntry[]) {
    entries.map((entry) => {
      const target = entry.target as HTMLDivElement;
      const classNameTarget = this.options?.target || target;
      if (entry.isIntersecting) {
        if (this.options?.callback && (this.options.once && !cl(target).has('visible-once') || !this.options.once)) {
          this.options?.callback(true, target, entry);
        }
        if (this.options?.class) {
          cl(classNameTarget).add(this.options?.class);
        } else {
          cl(classNameTarget).add('visible').add('visible-once');
        }
      } else if (!this.options?.once) {
        if (this.options?.class) {
          cl(classNameTarget).remove(this.options?.class);
        } else {
          cl(classNameTarget).remove('visible');
        }
        if (this.options?.callback) {
          this.options?.callback(false, target, entry);
        }
      }
    });
  }

  disconnect() {
    this.observer.disconnect();
  }
}
